export type FaqData = {
  question: string;
  answer: string;
};

export const FAQS_LANDING: FaqData[] = [
  {
    question: 'How do I store Get Real?',
    answer:
      'Keep it frozen to keep it fresh. Thaw Get Real in the fridge for 12-24 hours for the mixer (5 oz) and 12 oz packs, or 35-48 hours for the 24 oz packs. Use it up within 3-5 days. Throw away food that smells bad or has been out at room temp for more than 2 hours.',
  },
  {
    question:
      'How long do I have to put Get Real in the freezer after it’s delivered, in case I’m not home?',
    answer:
      'Don’t worry! Get Real is packed with insulation and dry ice and is designed to stay cold for 8 hours after it’s delivered (depending on weather conditions and where it’s left). Get your packs in the freezer as soon as possible, though, to be safe. If Get Real thaws, but still feels cold (40°F or below), you can refreeze or put it in the fridge. Use a food thermometer to be sure, or chat or call our customer care team 24/7 at 1-800-672-4399 if you’re not sure.',
  },
  {
    question: 'How do I switch from my dog’s current food to Get Real?',
    answer:
      'Start by gradually adding a small amount of Get Real to your dog’s current food. Increase the amount of Get Real and decrease the current food over the next 7-10 days. If you’re using Get Real to top your dog’s current food, start with a small amount and increase over time. Be sure to mix it in! For sensitive dogs, we recommend transitioning over 10-14 days.\n\nFor full-meal plans, we’ve even built in an extra week before your second order ships to allow time to transition without overloading your freezer.',
  },
  {
    question: 'Can I buy a sample of Get Real as a trial, or do I need to subscribe?',
    answer:
      'Yes! We now offer trial boxes in addition to subscriptions. After you input your dog’s information, you will see an option that says "Try it & love it sampler box". \n\nIf your dog loves it, come back and sign up for a subscription with a delivery frequency that works for you. You can change, cancel, or skip deliveries anytime.',
  },
  {
    question: 'How were the Get Real dog food recipes formulated?',
    answer:
      'A team of certified pet nutritionists here at Chewy collaborate with doctors in animal nutrition and food science to formulate Get Real.',
  },
  {
    question: 'Does Get Real meet AAFCO standards?',
    answer:
      'Yes! Our Get Real dog food recipes meet the nutritional levels established by the AAFCO Dog Food Nutrient Profiles for All Life Stages, including growth of large size dogs (70 lb. or more as an adult).',
  },
  {
    question: 'How is Get Real dog food made?',
    answer:
      'We start with recognizable, real, whole ingredients, mix them together, and cook it gently to retain nutrients. Then we pack and freeze it to lock in freshness.',
  },
  {
    question: 'Does Get Real dog food need to be cooked?',
    answer:
      'Nope! Get Real is ready to thaw and serve. Each recipe is gently cooked to keep in nutrients, and frozen to lock in freshness. No prep, no mess—just real food your pet will love.',
  },
  {
    question: 'How do you know how much food my dog needs? ',
    answer:
      'We use your dog’s weight, breed, age, and activity level to recommend the ideal amount to feed them every day. If you think your pup might need a different amount, you can chat or call our customer care team 24/7 at 1-800-672-4399.',
  },
  {
    question: 'Is Get Real dog food right for puppies or senior, pregnant, and nursing dogs?',
    answer:
      'Yes! Get Real is formulated to meet the nutritional levels established by the AAFCO Dog Food Nutrient Profiles for All Life stages. That includes puppies and senior, pregnant, and nursing dogs.',
  },
  {
    question: 'How do I order Get Real?',
    answer:
      'Tell us about your dog, and we’ll recommend a meal plan. Pick the recipes and frequency that work for you, and then get it delivered. You can change, cancel or pause your orders anytime!',
  },
  {
    question: 'How long does delivery of Get Real take?',
    answer:
      'Get Real is delivered within 1 day of shipping, to ensure it arrives cold and fresh. You’ll be notified by email or push notification when it ships, and to confirm it’s at your door.',
  },
];

export const FAQS_WELCOME: FaqData[] = [
  {
    question: 'How do I store Get Real?',
    answer:
      'Keep it frozen to keep it fresh. Thaw Get Real in the fridge for 12-24 hours for the mixer (5 oz) and 12 oz packs, or 35-48 hours  for the 24 oz packs. Use it up within 3-5 days. Throw away food that smells bad or has been out at room temp for more than 2 hours.',
  },
  {
    question: 'How do I switch from my dog’s current food to Get Real?',
    answer:
      'Start by gradually adding a small amount of Get Real to your dog’s current food. Increase the amount of Get Real and decrease the current food over the next 7-10 days. If you’re using Get Real to top your dog’s current food, start with a small amount and increase over time. Be sure to mix it in! For sensitive dogs, we recommend transitioning over 10-14 days.\n\nFor full-meal plans, we’ve even built in an extra week before your second order ships to allow time to transition without overloading your freezer.',
  },
  {
    question: 'How should I thaw Get Real?',
    answer:
      'The safest way to thaw Get Real dog food is in the fridge for 24-48 hours. If you need thawed food faster, put the sealed pack in a cold water bath to thaw. Throw away any food that’s been out at room temp for more than 2 hours.',
  },
  {
    question: 'What if I need to change or cancel my Get Real order?',
    answer:
      "You can change or cancel a future order up until the time we start packing your order. You can make changes where you manage your Autoship orders. We'll send you a reminder 3 days before your next scheduled order with a link to change or cancel.",
  },
  {
    question: 'How do I change my Get Real meal plan or delivery schedule?',
    answer:
      'You can change your plan anytime! Try new flavors, change the amount or frequency at your plan management page. (link to plan management page)',
  },
  {
    question: 'What if I run out of Get Real before my next order is scheduled? ',
    answer:
      "Your next order can ship earlier if it hasn't already been packed. Go to your plan management page and choose your meal plan. Go to Manage meal plan and on the Next order button choose the date you’d like the order to ship.",
  },
  {
    question: 'How do I skip, cancel, or start getting Get Real again?',
    answer:
      'Go to your plan management page and:\n  - Tap Skip to skip your upcoming order.\n  - To place your next order early, on the Next order button choose the date you’d like the order to ship.\n  - To change how often your order arrives, on your plan management page, tap Manage meal plan then on the meal plan page tap the frequency you’d like to change to.\n  - To change the date of your next order tap Manage meal plan and on the Next order button choose the date you’d like the order to ship.\n  You can change your order up to 48 hours before your next scheduled order. Look for an email, text, or notification reminder that your next order is shipping soon for the last day to change your order.\n  To start getting Get Real again, go to the Get Real page, tap Build your plan and enter your dog’s information again and choose the plan that’s right for you.',
  },
  {
    question: 'What if my dog doesn’t like Get Real?',
    answer:
      'Some dogs need a little more time to get used to fresh food. If yours doesn’t love Get Real after the transition, we can send you different recipes to try, or you can call (1-800-672-4399) or chat with us for a refund.',
  },
];
